import { Component } from "@angular/core";
import { AngularCropperjsModule } from "angular-cropperjs";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";

import { ScrollingModule } from "@angular/cdk/scrolling";
import { IonApp, IonRouterOutlet } from "@ionic/angular/standalone";

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.scss"],
    imports: [AngularCropperjsModule, FormsModule, NgSelectModule, ScrollingModule, IonApp, IonRouterOutlet],
})
export class AppComponent {}
